import React, { useEffect, useRef } from 'react'
import { MapContainer, TileLayer, Marker, Popup, MarkerProps, useMap } from 'react-leaflet'
import L, { LatLng } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
})

L.Marker.prototype.options.icon = DefaultIcon

const CenterForcingMarker: React.FC<MarkerProps> = (props) => {
  const map = useMap()
  const previousPositionRef = useRef<LatLng | null>(null)
  const hasCenteredRef = useRef<boolean>(false)

  useEffect(() => {
    // Only fly to position if it has actually changed
    // This prevents the map from jumping when user scrolls or zooms
    if (props.position) {
      // Convert LatLngExpression to LatLng to ensure consistent format
      const currentPos = L.latLng(props.position)
      const prevPos = previousPositionRef.current

      // Check if position has actually changed
      const positionChanged =
        !prevPos ||
        Math.abs(currentPos.lat - prevPos.lat) > 0.0001 ||
        Math.abs(currentPos.lng - prevPos.lng) > 0.0001

      // Only center the map if:
      // 1. Position has changed (new address selected)
      // 2. OR this is the first time we're setting a position (initial load)
      if (positionChanged && (!hasCenteredRef.current || positionChanged)) {
        map.flyTo(currentPos, map.getZoom() || 15)
        previousPositionRef.current = currentPos
        hasCenteredRef.current = true
      }
    }
  }, [props.position, map])

  return <Marker {...props} />
}

interface props {
  defaultCenter: LatLng
  defaultZoom: number
  pinnedAddress: string
  value?: LatLng
  style?: React.CSSProperties
}

/**
 * A map widget that displays a location.
 *
 * @param props
 * @return
 */
export const LocationView: React.FC<props> = ({ defaultCenter, defaultZoom, value, style, pinnedAddress }) => (
  <MapContainer center={defaultCenter} zoom={defaultZoom} style={style}>
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    {!value || (
      <CenterForcingMarker position={value}>
        <Popup>{pinnedAddress}</Popup>
      </CenterForcingMarker>
    )}
  </MapContainer>
)

// https://github.com/PaulLeCam/react-leaflet/issues/453#issuecomment-787888924
